import { Sparkles } from "lucide-react";
import { UPLOADS_URL } from "../../config/constants";
import { getActivityImageSrc, getPostActivityImageSrc } from "./activityHelpers";
import { resolvePostActivity } from "../posts/postHelpers";
import "./activities.css";

const ICON_SIZES = {
  sm: 14,
  md: 20,
  lg: 36,
};

export default function ActivityAvatar({
  activity,
  post,
  activities = [],
  size = "md",
  className = "",
  title,
}) {
  const resolvedActivity = post ? resolvePostActivity(post, activities) : activity;
  const imageSrc = post
    ? getPostActivityImageSrc(post, resolvedActivity, UPLOADS_URL)
    : getActivityImageSrc(resolvedActivity, UPLOADS_URL);
  const label = title || resolvedActivity?.title || activity?.title || "Activity";
  const sizeClass = size === "sm" || size === "lg" ? `is-${size}` : "";

  return (
    <span className={`act-thumb-wrap activity-avatar ${sizeClass} ${className}`.trim()}>
      {imageSrc ? (
        <img className="act-thumb" src={imageSrc} alt={label} loading="lazy" />
      ) : (
        <Sparkles size={ICON_SIZES[size] || ICON_SIZES.md} strokeWidth={1.8} color="#7c3aed" />
      )}
    </span>
  );
}
